import "jquery";
import "lodash";
import "timeago";
import "./polyfills";
import "./setup/bootstrap";
import "./shim/tcbase";
